import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.scss";
import { Provider as FormProvider } from "./context/formContext/FormContext";
import { LanguageProvider } from "./context/languageContext/LanguageContext";
import LanguagePath from "./context/languageContext/LanguagePath";
import { Provider as SuggestionProvider } from "./context/suggestionContext/SuggestionContext";
import { Provider as WikiProvider } from "./context/wikiContext/WikiContext";
import FormContainer from "./pages/FormContainer";
import RedirectToForm from "./pages/RedirectToForm";

export const router = createBrowserRouter([
  {
    path: "/:lang",
    element: <LanguagePath />,
    children: [
      {
        path: "form",
        element: <FormContainer />,
      },
      {
        path: "",
        element: <RedirectToForm />,
      },
      {
        path: "*",
        element: <RedirectToForm />,
      },
    ],
  },
  {
    path: "/",
    element: <RedirectToForm />,
  },
]);

function App() {
  /* const router = createBrowserRouter([
    {
      path: "/",
      element: <FormContainer></FormContainer>,
    },
    {
      path: "/*",
      element: <RedirectToForm />,
    },
  ]); */

  return (
    <>
      <SuggestionProvider>
        <LanguageProvider>
          <FormProvider>
            <WikiProvider>
              <RouterProvider
                router={router}
                fallbackElement={<div>asdfads</div>}
              />
            </WikiProvider>
          </FormProvider>
        </LanguageProvider>
      </SuggestionProvider>
    </>
  );
}

export default App;
